<template>
    <div
        class="flex items-center bg-primary rounded-[10px] p-[30px] lg:py-[40px] lg:pl-[70px] lg:pr-[30px] max-lg:flex-col"
    >
        <BasicIcon
            name="logo-white"
            class="fill-font-4"
            size="70"
        >
        </BasicIcon>
        <p
            class="flex-1 text-2xl text-font-4 lg:ml-[75px] lg:mr-[30px] max-lg:text-center max-lg:my-5"
        >
            {{ translations.banner }}
        </p>
        <BasicNuxtLink
            id="free-singup-button"
            color="secondary"
            :is-link="false"
            href="https://clickmeeting.com/pl/free-signup?a=ats"
            @click="trackClickedBanner"
        >
            {{ translations.button }}
        </BasicNuxtLink>
    </div>
</template>

<script setup lang="ts">
import BasicIcon from '@atoms/BasicIcon/BasicIcon.vue';
import BasicNuxtLink from '@atoms/BasicNuxtLink.vue';
import { AmplitudeEvents } from '@utils/trackingEvents';

const { t } = useI18n();
const { $analyticsTrack } = useNuxtApp();

const trackClickedBanner = async () => {
    await $analyticsTrack(AmplitudeEvents.attendeeClickedBanner, {
        banner: 'try-free-trail',
    });
};

const translations = computed(() => {
    return {
        banner: t('atp.banner.create_cm_account.title'),
        button: t('atp.button.try_free_trail'),
    };
});
</script>
